import { CheckCircle2, Circle } from "lucide-react";

export default function SkillChecklist({ data, memberId, onToggle }) {
  return (
    <div className="mt-4 pt-4 border-t border-border space-y-1.5" data-testid={`skill-list-${memberId}`}>
      <div className="text-xs uppercase tracking-wider text-muted-foreground font-semibold mb-2">{data.award_name}</div>
      {data.skills.map((s) => (
        <button key={s.skill}
          className="w-full flex items-center justify-between gap-2 py-2 min-h-[44px] text-left rounded-lg px-2 hover:bg-secondary transition-colors"
          onClick={() => onToggle(s.skill, s.achieved)}
          data-testid={`skill-toggle-${memberId}-${s.skill.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
          <span className="flex items-center gap-2">
            {s.achieved
              ? <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0" />
              : <Circle className="w-5 h-5 text-muted-foreground shrink-0" />}
            <span className={`text-sm ${s.achieved ? "font-medium" : "text-muted-foreground"}`}>{s.skill}</span>
          </span>
          {s.achieved && s.achieved_on && <span className="text-xs text-muted-foreground">{s.achieved_on}</span>}
        </button>
      ))}
    </div>
  );
}
